import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import NewButton from '@atlaskit/button/new';
import Button from '@atlaskit/button/standard-button';
import ChevronDownIcon from '@atlaskit/icon/utility/chevron-down';
import ChevronDownIconOld from '@atlaskit/icon/utility/migration/chevron-down';
import { fg } from '@atlaskit/platform-feature-flags';
export var PopupTrigger = function PopupTrigger(_ref) {
  var triggerProps = _ref.triggerProps,
    isSelected = _ref.isSelected,
    labelPrefix = _ref.labelPrefix,
    selectedLabel = _ref.selectedLabel,
    onClick = _ref.onClick;
  if (fg('platform-linking-visual-refresh-sllv')) {
    return /*#__PURE__*/React.createElement(NewButton, _extends({}, triggerProps, {
      testId: 'confluence-search-modal--date-range-button',
      onClick: onClick,
      isSelected: isSelected,
      iconAfter: function iconAfter() {
        return /*#__PURE__*/React.createElement(ChevronDownIcon, {
          label: "",
          color: "currentColor"
        });
      }
    }), labelPrefix, selectedLabel ? ": ".concat(selectedLabel) : '');
  }
  return /*#__PURE__*/React.createElement(Button, _extends({}, triggerProps, {
    testId: 'confluence-search-modal--date-range-button',
    onClick: onClick,
    isSelected: isSelected,
    iconAfter:
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(ChevronDownIconOld, {
      LEGACY_size: "medium",
      label: "",
      color: "currentColor"
    }))
  }), labelPrefix, selectedLabel ? ": ".concat(selectedLabel) : '');
};